// Combine all reducers in this file and export the combined reducers //
import { combineReducers } from 'redux';

// ================== Product reducers ================== //

import global from 'products/global/state/reducer';
import nomadInsurance from 'products/nomad_insurance/state/reducer';

// ================== Global app state ================== //
import app from './app';

const appReducer = combineReducers({
  app,
  global,
  nomadInsurance
});

export type RootState = ReturnType<typeof appReducer>;

const rootReducer = (state: any, action: any) => {
  if (action.type === 'RESET_APP') {
    state = undefined;
  }

  return appReducer(state, action);
};

export default function createReducer() {
  return rootReducer;
}
